export default [
  { value: 'sale', label: 'Venta' },
  { value: 'rent', label: 'Arriendo' },
  { value: 'both', label: 'Ambos' },
];



// WEBPACK FOOTER //
// ./src/utils/selectors/SaleRentOptions.js